import React from 'react'
import Icons from '../../myIcon/Icons';
import { Link } from 'react-router-dom';

export default function BoardModal({ onClose, data }) {
  
  if (!data) return null;

  return (
    <>
      <div className="board-modal-overlay">
        <div className="board-modal-box">
          <button className="board-modal-close" onClick={onClose}>✕</button>
          <div className="board-modal-content">
            <img src={data.img} alt={data.name} />
            <div className="board-modal-text">
              <span>{data.name}</span>
              <label>{data.role}</label>
              <p>{data.description}</p>
              <ul>
                {data?.facebook && <li><Link target='_blank' to={data?.facebook}><Icons name="facebook" /></Link></li>}
                {data?.insta && <li><Link target='_blank' to={data?.insta}><Icons name="instagram" /></Link></li>}
                {data?.twitter && <li><Link target='_blank' to={data?.twitter}><Icons name="twitter" /></Link></li>}
               {data?.linkedin && <li><Link target='_blank' to={data?.linkedin}><Icons name="linkedin" /></Link></li>}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
